/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Limited_Compatibility_ShortInputs */

const en_common_limited_compatibility_short = /** @type {(inputs: Common_Limited_Compatibility_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited compatibility`)
};

const es_common_limited_compatibility_short = /** @type {(inputs: Common_Limited_Compatibility_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compatibilidad limitada`)
};

/**
* | output |
* | --- |
* | "Limited compatibility" |
*
* @param {Common_Limited_Compatibility_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_limited_compatibility_short = /** @type {((inputs?: Common_Limited_Compatibility_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Limited_Compatibility_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_limited_compatibility_short(inputs)
	return en_common_limited_compatibility_short(inputs)
});